export default {
    isbind:false,
    stu_name:'',
    stu_num:'',
    stu_major:'',
    stu_class:'',
    stu_phone:'',
    stu_idcard:'',
    stu_grade:'',
    stu_status:'',
    open_id:'',
    nickname:'',
    headImgUrl:''

}


//////////////////
// WEBPACK FOOTER
// ./store/state.js
// module id = null
// module chunks = 